import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
import { price } from '../data/content';
const pad = (n: number) => n.toString().padStart(2, '0');
export function CountdownBar() {
  const {
    days,
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: days,
    label: 'días'
  }, {
    value: hours,
    label: 'horas'
  }, {
    value: minutes,
    label: 'minutos'
  }, {
    value: seconds,
    label: 'segundos'
  }];
  return <div className="sticky top-0 z-40 w-full border-b-2 border-ink bg-ink text-cream" data-id="element-28" data-mp="2hfahti3jp821">
      <div className="mx-auto flex max-w-6xl flex-col items-center justify-center gap-1 px-3 py-2 sm:gap-2 sm:px-4 sm:py-2.5 sm:flex-row sm:gap-6" data-id="element-29" data-mp="2hhn94lv70urr">
        <p className="font-display text-[11px] font-bold uppercase tracking-wider text-rust sm:text-sm" data-id="element-30" data-mp="28fnqxq8fzkn8">
          La oferta de {price.today} termina en
        </p>
        <div className="flex items-center gap-1.5 sm:gap-2" role="timer" aria-live="off" data-id="element-31" data-mp="6n99es9t8i7c">
          {units.map((u, i) => <React.Fragment key={u.label} data-id="element-32" data-mp="13eafm1z8yngk" data-mpi={i}>
              <div className="flex items-baseline gap-1" data-id="element-33" data-mp="13cfryfwlch8s">
                <span className="font-display text-lg font-black tabular-nums sm:text-2xl" data-id="element-34" data-mp="18dn04g2nbifz">{pad(u.value)}</span>
                <span className="text-[11px] text-kraft-light sm:text-xs" data-id="element-35" data-mp="ue458oyui3lm">{u.label}</span>
              </div>
              {i < units.length - 1 && <span className="font-display text-lg font-black text-kraft-dark" data-id="element-36" data-mp="yf7jj718vrkq">:</span>}
            </React.Fragment>)}
        </div>
      </div>
    </div>;
}